import { Injectable, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ENVIRONMENT } from '@athena/util';

@Injectable({
  providedIn: 'root',
})
export class SocialTagsService {
  private titleService = inject(Title);
  private metaService = inject(Meta);
  private environment = inject(ENVIRONMENT);

  setTitle(title?: string): void {
    // Update title tag
    let updatedTitle = 'petdatabase.com';
    if (title) {
      updatedTitle = `${title} | ${updatedTitle}`;
    }
    this.titleService.setTitle(updatedTitle);

    // Update socials title meta tags
    this.metaService.updateTag({
      property: 'og:title',
      content: updatedTitle,
    });
    this.metaService.updateTag({
      name: 'twitter:title',
      content: updatedTitle,
    });
  }

  setDescription(description?: string): void {
    // Update main description meta tag
    const updatedDescription =
      description ||
      'Pet Database a national Defra compliant pet database containing the details of microchipped pets with a UK-wide lost pet service - helping keep pets safe and found.';
    this.metaService.updateTag({
      name: 'description',
      content: updatedDescription,
    });

    // Update socials description meta tags
    this.metaService.updateTag({
      property: 'og:description',
      content: updatedDescription,
    });
    this.metaService.updateTag({
      name: 'twitter:description',
      content: updatedDescription,
    });
  }

  setImage(image?: string): void {
    let updatedImage: string;
    if (image && /^(http:\/\/|https:\/\/)/.test(image)) {
      updatedImage = image;
    } else {
      updatedImage = `${this.environment.canonicalUrl}/assets/images/socials/${image || 'default.png'}`;
    }
    // Update socials image meta tags
    this.metaService.updateTag({
      property: 'og:image',
      content: updatedImage,
    });
    this.metaService.updateTag({
      name: 'twitter:image',
      content: updatedImage,
    });
  }
}
